import Vue from 'vue';
import Vuex from 'vuex';
import PortalVue from 'portal-vue';
//import { onAppReady } from 'larasnap';
import capitalize from 'lodash-es/capitalize';
//import debounce from 'lodash-es/debounce';
import { createPopover } from '../classes/core/Popover';
import { closePopup } from 'larasnap/support';
import Newlines from 'larasnap/assets/vue/support/newlines/Newlines.vue';

window.Vue = Vue;
window.Vuex = Vuex;

Vue.use(Vuex);
Vue.use(PortalVue);

const isDev = process.env.NODE_ENV !== 'production';

Vue.config.devtools = isDev;
Vue.config.performance = isDev;

// Directives

Vue.directive('select-on-focus', {
    bind: function (el) {
        el.addEventListener('focus', () => {
            el.select();
        });
    },
});

Vue.directive('close-popup', {
    bind: function (el) {
        el.addEventListener('click', closePopup);
    },
});

function popover(el, binding) {
    el = $(el);

    const options = {
        content: '',
        title: '',
        trigger: 'hover',
        html: true,
        placement: Object.keys(binding.modifiers)[0] ?? 'auto',
        container: 'body',
        boundary: 'viewport', // Default is 'window' which causes problems with vertical placement  when the element is near the bottom of the screen
    };

    if (typeof binding.value === 'string') {
        options.content = binding.value;
    } else {
        Object.assign(options, binding.value);
    }

    if (options.content) {
        createPopover(el, options);
    } else {
        el.popover('dispose');
    }
}

Vue.directive('datepicker', {
    bind: function (el, binding, vnode) {
        const options = {
            autoclose: true,
            format: 'm/d/yyyy',
        };

        $(el)
            .datepicker({ ...options, ...binding.value })
            .on('changeDate', e => {
                if (vnode.data.on && vnode.data.on.input) {
                    vnode.data.on.input(e);
                }
                if (vnode.data.on && vnode.data.on.change) {
                    vnode.data.on.change(e);
                }
            });
    },
});

Vue.directive('popover', {
    bind: popover,
    update: popover,
    unbind: el => {
        $(el).popover('dispose');
    },
});

function tooltip(el, binding) {
    el = $(el);

    const options = {
        title: '',
        html: true,
        placement: Object.keys(binding.modifiers)[0] ?? 'top',
        container: 'body',
        boundary: 'viewport', // Default is 'window' which causes problems with vertical placement  when the element is near the bottom of the screen
    };

    if (typeof binding.value === 'string') {
        options.title = binding.value;
    } else {
        Object.assign(options, binding.value);
    }

    el.tooltip('dispose');

    if (options.title) {
        el.tooltip(options);
    }
}

Vue.directive('tooltip', {
    bind: tooltip,
    update: tooltip,
    unbind: el => {
        $(el).tooltip('dispose');
    },
});

/* const getAdminLteContentAreaHeight = () => {
    const nonContentAreaHeight =
        $('header').outerHeight() +
        ($('.content').outerHeight() - $('.content').height());
    return $(window).height() - nonContentAreaHeight;
};

Vue.directive('fluid-height', {
    bind: function (el) {
        const autosizeToWindow = debounce(() => {
            $(el).height(getAdminLteContentAreaHeight());
        }, 10);
        onAppReady(autosizeToWindow);
        $(window).resize(autosizeToWindow);
    },
}); */

Vue.directive(
    'table-header-scrollbar-spacer',
    (() => {
        const defaultConfig = {
            defaultWidth: 17,
        };

        const getScrollbarWidth = () => {
            const div = document.createElement('div');
            div.style.width = '100px';
            div.style.height = '100px';
            div.style.overflow = 'scroll';
            div.style.position = 'absolute';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            const scrollbarWidth = div.offsetWidth - div.clientWidth;
            document.body.removeChild(div);
            return scrollbarWidth;
        };

        const computeHeaderMargin = (tbody, scrollbarWidth, spacer) => {
            if (tbody.scrollHeight > tbody.offsetHeight) {
                spacer.style.width = `${scrollbarWidth}px`;
                spacer.style.display = 'table-cell';
            } else {
                spacer.style.display = 'none';
            }
        };

        const getDisplayNoneParent = el => {
            while (el.parentElement) {
                el = el.parentElement;
                if (getComputedStyle(el, null).display === 'none') {
                    return el;
                }
            }
        };

        return {
            inserted(el, binding) {
                const tbody = el.getElementsByTagName('tbody')[0];
                const config = Object.assign({}, defaultConfig, binding.value);

                // Create the spacer element that will be inserted into the table header row
                const spacer = document.createElement('th');
                spacer.style.width = 0;

                // We want to ensure that the spacer element is the last <th> in the header row.
                // To do this we will wait for a header row mutation that involves its children.
                // This should be the rendering of all the other <th> elements. Once that is
                // complete we add the spacer element and disconnect the observer
                const headerRow = el.querySelector('thead tr');
                const tableHeaderObserver = new MutationObserver(() => {
                    headerRow.appendChild(spacer);
                    tableHeaderObserver.disconnect();
                });
                tableHeaderObserver.observe(headerRow, { childList: true });

                // Determine the scrollbar with for the current browser. If it cannot be determined
                // then use the default width instead
                let scrollbarWidth = getScrollbarWidth();
                if (scrollbarWidth === 0) {
                    scrollbarWidth = config.defaultWidth;
                }

                // Check if this element is currently hidden (not rendered) due to an ancestor
                // element having display="none". If so subscribe to attribute changes for that
                // element so we can act on the event of this element becoming visible and its
                // children being rendered. At this point we want to run computeHeaderMargin now
                // that we can determine the tbody scrollHeight
                const parent = getDisplayNoneParent(el);
                if (parent) {
                    const containerObserver = new MutationObserver(() => {
                        computeHeaderMargin(tbody, scrollbarWidth, spacer);
                    });
                    containerObserver.observe(parent, { attributes: true });
                    $(el).data('containerObserver', containerObserver);
                }

                // Whenever mutations occur to the tbody element run computeHeaderMargin. This
                // will capture events where rows are being added or removed from the table and
                // hence the tbody scrollbar appearing and disappearing
                const observer = new MutationObserver(() => {
                    computeHeaderMargin(tbody, scrollbarWidth, spacer);
                });
                observer.observe(tbody, { childList: true, attributes: true });
                $(el).data('observer', observer);
            },
            unbind(el) {
                if ($(el).data('observer')) {
                    $(el).data('observer').disconnect();
                }
                if ($(el).data('containerObserver')) {
                    $(el).data('containerObserver').disconnect();
                }
            },
        };
    })(),
);

// Filters

Vue.filter('capitalize', function (str) {
    return capitalize(str);
});

// Plugins

import VueVisible from 'vue-visible';
Vue.use(VueVisible);

// Apps

import '../../vue/snapgrid';
import '../../vue/form/multi_input';

// Global Components

Vue.component('g-newlines', Newlines);
